export enum PersonPages {
  BasicInfo = 'basic-info',
  Profiles = 'profiles',
}

export default PersonPages;
